/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BoardEarnObjectiveAction } from './BoardEarnObjectiveAction';
import {
    BoardEarnObjectiveActionFromJSON,
    BoardEarnObjectiveActionFromJSONTyped,
    BoardEarnObjectiveActionToJSON,
    BoardEarnObjectiveActionToJSONTyped,
} from './BoardEarnObjectiveAction';

/**
 * 
 * @export
 * @interface BoardEarnObjective
 */
export interface BoardEarnObjective {
    /**
     * What a claim submits against; also the card's identity.
     * @type {string}
     * @memberof BoardEarnObjective
     */
    objectiveTemplateId: string;
    /**
     * Card header.
     * @type {string}
     * @memberof BoardEarnObjective
     */
    name: string;
    /**
     * Front-card blurb.
     * @type {string}
     * @memberof BoardEarnObjective
     */
    description?: string;
    /**
     * Back-card body — how the points are earned. Line breaks preserved.
     * @type {string}
     * @memberof BoardEarnObjective
     */
    instructions?: string;
    /**
     * Opaque key the surface colours the card ring by.
     * @type {string}
     * @memberof BoardEarnObjective
     */
    category?: string;
    /**
     * The value that actually pays — the assigned LEADERBOARD_POINTS reward's amount.
     * @type {number}
     * @memberof BoardEarnObjective
     */
    points: number;
    /**
     * The unit under the number, from the objective's rewardPer. Absent takes the section's default.
     * @type {string}
     * @memberof BoardEarnObjective
     */
    pointsLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof BoardEarnObjective
     */
    displayPriority?: number;
    /**
     * 
     * @type {BoardEarnObjectiveAction}
     * @memberof BoardEarnObjective
     */
    action?: BoardEarnObjectiveAction;
    /**
     * Signed-in member only — this claim card is used up (current post already liked, the period's cap reached, or the follow already claimed). The card renders done and cannot be opened.
     * @type {boolean}
     * @memberof BoardEarnObjective
     */
    claimComplete?: boolean;
}

/**
 * Check if a given object implements the BoardEarnObjective interface.
 */
export function instanceOfBoardEarnObjective(value: object): value is BoardEarnObjective {
    if (!('objectiveTemplateId' in value) || value['objectiveTemplateId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    return true;
}

export function BoardEarnObjectiveFromJSON(json: any): BoardEarnObjective {
    return BoardEarnObjectiveFromJSONTyped(json, false);
}

export function BoardEarnObjectiveFromJSONTyped(json: any, ignoreDiscriminator: boolean): BoardEarnObjective {
    if (json == null) {
        return json;
    }
    return {
        
        'objectiveTemplateId': json['objectiveTemplateId'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'instructions': json['instructions'] == null ? undefined : json['instructions'],
        'category': json['category'] == null ? undefined : json['category'],
        'points': json['points'],
        'pointsLabel': json['pointsLabel'] == null ? undefined : json['pointsLabel'],
        'displayPriority': json['displayPriority'] == null ? undefined : json['displayPriority'],
        'action': json['action'] == null ? undefined : BoardEarnObjectiveActionFromJSON(json['action']),
        'claimComplete': json['claimComplete'] == null ? undefined : json['claimComplete'],
    };
}

export function BoardEarnObjectiveToJSON(json: any): BoardEarnObjective {
    return BoardEarnObjectiveToJSONTyped(json, false);
}

export function BoardEarnObjectiveToJSONTyped(value?: BoardEarnObjective | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'objectiveTemplateId': value['objectiveTemplateId'],
        'name': value['name'],
        'description': value['description'],
        'instructions': value['instructions'],
        'category': value['category'],
        'points': value['points'],
        'pointsLabel': value['pointsLabel'],
        'displayPriority': value['displayPriority'],
        'action': BoardEarnObjectiveActionToJSON(value['action']),
        'claimComplete': value['claimComplete'],
    };
}

